import {Injectable} from "@angular/core";
import {HttpInterceptor} from "@angular/common/http";

@Injectable({
  providedIn: 'root'
})
export class FormatHelper {
  convertToDoubleDigits(value: number) {
    if(value < 10) {
      return `0${value}`;
    }
    return `${value}`;
  }
}
